// Academic year utilities (India: April – March)

export function academicYearForDate(date) {
  const d = date instanceof Date ? date : new Date(date);
  const y = d.getFullYear();
  const startYear = d.getMonth() >= 3 ? y : y - 1;         // Apr–Dec => y; Jan–Mar => y-1
  const endYY = String((startYear + 1) % 100).padStart(2, "0");
  return `${startYear}-${endYY}`;
}

export function academicYearRange(ayear) {
  // "2025-26" -> {start: 2025-04-01, end: 2026-03-31}
  const [y1] = ayear.split("-");
  const start = new Date(Number(y1), 3, 1);                // April 1
  const end = new Date(Number(y1) + 1, 2, 31, 23, 59, 59); // March 31
  return { start, end };
}

// Build a list of academic years covering a range
export function listAcademicYears(fromYear = 2012, toYear = 2030) {
  const list = [];
  for (let y = fromYear; y <= toYear; y++) list.push(academicYearForDate(new Date(y, 3, 15)));
  return list;
}
